/**
 * ring-sizer: 选码工具（输入手指周长 → 推荐 US 码）。
 * 源自 web-hand-off ring-sizer.js：删 partials:loaded，保留 shopify:section:load。
 *
 * 尺寸表来自 HTML（隐藏数据列表 [data-sizer-chart] 内 [data-size]/[data-dia]/[data-circ]，单位 mm），本文件不持有内容。
 * 输入周长 → 换算内径 → 匹配规则对齐品牌《欧美市场测量方案》：
 * 只用 US 整码，测量值介于两码之间一律取大（roundUpIdx，非最近邻）。
 * 2026-08-04 v2：旧版同心圆视觉、单位切换和对比滑块均已下线，本文件只负责「输入 → 推荐码」。
 * 幂等，shopify:section:load 后重新初始化。
 */
(function () {
  var PI = Math.PI;

  function chartOf(root) {
    var page = root.closest('[data-component="support-sizer"]') || document;
    return [...page.querySelectorAll('[data-sizer-chart] [data-size]')].map(function (el) {
      return { size: el.dataset.size, dia: parseFloat(el.dataset.dia), circ: parseFloat(el.dataset.circ) };
    });
  }

  // 介于两码之间取大：选择第一个内径 >= 测量值的码；0.05mm 容差用于吸收读数抖动。
  function roundUpIdx(chart, dia) {
    for (var i = 0; i < chart.length; i++) {
      if (chart[i].dia >= dia - 0.05) return i;
    }
    return chart.length - 1;
  }

  function set(root, selector, text) {
    var el = root.querySelector(selector);
    if (el) el.textContent = text;
  }

  function recompute(root, chart) {
    var input = root.querySelector('[data-sizer-input]');
    var value = parseFloat(input && input.value);
    if (!isFinite(value) || value <= 0) return;
    var size = chart[roundUpIdx(chart, value / PI)];
    set(root, '[data-sizer-size]', 'US ' + size.size);
    set(root, '[data-sizer-dia]', size.dia.toFixed(1) + ' mm');
    set(root, '[data-sizer-circ]', size.circ.toFixed(1) + ' mm');
  }

  function init() {
    document.querySelectorAll('[data-sizer]').forEach(function (root) {
      if (root.dataset.sizerReady) return;
      root.dataset.sizerReady = '1';
      var chart = chartOf(root);
      if (!chart.length) return;
      var input = root.querySelector('[data-sizer-input]');
      if (input) input.addEventListener('input', function () { recompute(root, chart); });
      recompute(root, chart);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
